import React from 'react'

interface ProcessIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
  style?: React.CSSProperties
}

const ProcessIcon: React.FC<ProcessIconProps> = ({
  color = '#888',
  gradient,
  width = 24,
  height = 24,
  alt = 'Process icon',
  style = {},
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
      style={style}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <g clipPath='url(#clip0_6142_10080)'>
        <path
          fill={gradient ? 'url(#grad1)' : color}
          d='M8.315 11.339H.661A.66.66 0 000 12v8.315a.66.66 0 00.661.661h10.935v1.32l3.428-1.981-3.428-1.98v1.319H1.323V12.66h6.992v3.024h7.37v-7.37h-7.37v3.024zm1.323-1.701h4.724v4.724H9.638V9.638zM16.63 24H24v-7.37h-7.37V24zm1.323-6.047h4.724v4.724h-4.724v-4.724zm5.386-14.93H7.37V0H0v7.37h7.37V4.346h15.307v6.993H20.72v-1.32L17.291 12l3.428 1.98v-1.319h2.62A.66.66 0 0024 12V3.685a.66.66 0 00-.661-.661zM6.047 6.048H1.323V1.323h4.724v4.724z'
        ></path>
      </g>
      <defs>
        <clipPath id='clip0_6142_10080'>
          <path fill='#fff' d='M0 0H24V24H0z'></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default ProcessIcon
